import React, { useEffect, useRef, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Training } from "@/components/site/Training";
import { Marquee } from "@/components/site/Marquee";
import { Leadership } from "@/components/site/Leadership";
import { Team } from "@/components/site/Team";
import { Gallery } from "@/components/site/Gallery";
import { WhyPeil } from "@/components/site/WhyPeil";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: id === "hero" ? 0 : -1 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div className="App grain min-h-screen bg-brand-base text-brand-text antialiased">
      <Nav scrollTo={scrollTo} />
      <main>
        <Hero scrollTo={scrollTo} />
        <Manifesto />
        <Services />
        <Training />
        <Marquee />
        <Leadership />
        <Team />
        <Gallery />
        <WhyPeil />
        <Contact />
      </main>
      <Footer scrollTo={scrollTo} />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
